import {useState} from 'react';

const useModal = () => {
  const [stateAddress, setIsShowing] = useState({
    show: false,
    isClose: false,
    payload: [],
  });

  function toggleShow() {
    setIsShowing((stateAddress) => ({
      ...stateAddress,
      show: true,
      isClose: false,
    }));
  }

  function toggleHide(isClose = false) {
    setIsShowing((stateAddress) => ({
      ...stateAddress,
      show: false,
      isClose: isClose,
    }));
  }

  function setPayloadOnHide(payload) {
    setIsShowing((stateAddress) => ({
      ...stateAddress,
      show: false,
      payload: payload,
      isClose: false,
    }));
  }

  return {
    stateAddress,
    toggleShow,
    toggleHide,
    setPayloadOnHide,
  };
};

export default useModal;
